import React from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header style={{
      background: 'var(--bg-page)',
      position: 'fixed',
      top: '32px',
      width: '100%',
      zIndex: 99999,
      padding: '0 12px'
    }}>
      <div style={{
        maxWidth: '1440px',
        margin: '0 auto',
        background: 'var(--brand-dark)',
        borderRadius: '25px',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0, 69, 52, 0.25)'
      }}>
        <div style={{
          fontSize: '18px',
          fontWeight: 600,
          color: 'white',
          cursor: 'pointer'
        }} onClick={() => scrollToSection('hero')}>
          Gross Coaching
        </div>

        {/* Desktop Navigation */}
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          gap: '24px'
        }} className="desktop-nav">
          <a onClick={() => scrollToSection('programm')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 16px',
            borderRadius: '20px',
            transition: 'background 0.2s ease',
            cursor: 'pointer'
          }}>Programm</a>
          <a onClick={() => scrollToSection('tarife')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 16px',
            borderRadius: '20px',
            transition: 'background 0.2s ease',
            cursor: 'pointer'
          }}>Tarife</a>
          <a onClick={() => scrollToSection('uber-alex')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 16px',
            borderRadius: '20px',
            transition: 'background 0.2s ease',
            cursor: 'pointer'
          }}>Über Alex</a>
          <a onClick={() => scrollToSection('kontakt')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 16px',
            borderRadius: '20px',
            transition: 'background 0.2s ease',
            cursor: 'pointer'
          }}>Kontakt</a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '8px'
          }}
          className="mobile-menu-btn"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div style={{
          background: 'var(--brand-dark)',
          borderRadius: '25px',
          marginTop: '8px',
          padding: '16px',
          maxWidth: '1440px',
          margin: '8px auto 0',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          <a onClick={() => scrollToSection('programm')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '12px 16px',
            borderRadius: '20px',
            cursor: 'pointer'
          }}>Programm</a>
          <a onClick={() => scrollToSection('tarife')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '12px 16px',
            borderRadius: '20px',
            cursor: 'pointer'
          }}>Tarife</a>
          <a onClick={() => scrollToSection('uber-alex')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '12px 16px',
            borderRadius: '20px',
            cursor: 'pointer'
          }}>Über Alex</a>
          <a onClick={() => scrollToSection('kontakt')} style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: 500,
            padding: '12px 16px',
            borderRadius: '20px',
            cursor: 'pointer'
          }}>Kontakt</a>
        </div>
      )}

      <style>{`
        @media (max-width: 781px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
          header {
            top: 0 !important;
          }
        }
      `}</style>
    </header>
  );
};